/**
 * AI Recruit - Assignment Badge Component
 * Displays who is assigned to a resume or job match
 */

import React from 'react'

interface AssignmentBadgeProps {
  userName: string | null
  assignmentType?: 'auto' | 'manual' | 'unassigned'
  onClick?: () => void
  clickable?: boolean
}

const AssignmentBadge: React.FC<AssignmentBadgeProps> = ({
  userName,
  assignmentType = 'manual',
  onClick,
  clickable = false,
}) => {
  const getBadgeColor = () => {
    switch (assignmentType) {
      case 'auto':
        return 'bg-green-100 text-green-800 border-green-300'
      case 'manual':
        return 'bg-blue-100 text-blue-800 border-blue-300'
      case 'unassigned':
        return 'bg-gray-100 text-gray-600 border-gray-300'
      default:
        return 'bg-blue-100 text-blue-800 border-blue-300'
    }
  }

  const badgeClasses = `inline-flex items-center px-2 py-1 rounded-full text-sm font-medium border ${getBadgeColor()} ${
    clickable ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''
  }`

  return (
    <span
      className={badgeClasses}
      onClick={clickable ? onClick : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
    >
      {userName || 'Unassigned'}
    </span>
  )
}

export default AssignmentBadge
